<template>
  <div class="user-page login-bj cl">
    <section class="user login-content">
      <div class="login-form plg-flex-item">
        <div class="logo form-logo"></div>

        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
        >
          <a-form-item :hasFeedback="true">
            <a-input
              size="large"
              v-decorator="[
                'username',
                {
                  rules: [{ required: true, message: '请输入用户名!' }],
                },
              ]"
              placeholder="请输入用户名"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item :hasFeedback="true">
            <a-input-password
              visibilityToggle
              size="large"
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请输入密码!' }],
                },
              ]"
              type="password"
              placeholder="请输入密码"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input-password>
          </a-form-item>
          <a-form-item>
            <a-button
              size="large"
              type="primary"
              html-type="submit"
              :loading="loginBtn"
              :disabled="loginBtn"
              class="login-form-button"
              >登陆
            </a-button>
          </a-form-item>
          <a-alert
            v-if="isLoginError"
            type="error"
            show-icon
            closable
            :message="loginMessage"
            :after-close="handleClose"
          />
        </a-form>
      </div>
    </section>
  </div>
</template>

<script>
import qs from "qs";
import storage from "store";

export default {
  data() {
    return {
      isLoginError: false,
      loginMessage: "",
      loginBtn: false,
    };
  },
  beforeCreate() {
    // storage.remove("access_token");
    // console.log("storage", storage);
    // debugger;
    storage.clearAll();
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  mounted() {
    document.body.addEventListener("keyup", this.keyup, false);
  },
  destroyed() {
    document.body.removeEventListener("keyup", this.keyup);
    this.keyup = null;
  },
  methods: {
    keyup(e) {
      if (e.keyCode == 13) {
        this.handleSubmit(e);
      }
    },
    loginSuccess(res) {
      storage.set("access_token", res.data.token);
      storage.set("expire", res.data.expir);
      this.$router.push({ path: "home" });
    },
    handleClose() {
      this.isLoginError = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      let _this = this;
      this.form.validateFields((err, values) => {
        if (err) return;
        const { username, password } = values;
        this.loginBtn = true;
        this.isLoginError = false;

        this.axios({
          method: "post",
          url: _this.$apis.authLogin(),
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
          data: qs.stringify({
            username,
            password,
          }),
        })
          .then((res) => {
            if (res.success) {
              this.loginSuccess(res);

            } else {
              this.loginMessage =
                res.message == "Bad credentials"
                  ? "账号或密码错误"
                  : res.message;
              this.isLoginError = true;
            }
          })
          .finally(() => {
            this.loginBtn = false;
          });
      });
    },
  },
};
</script>
<style lang="less">
.login-form-button {
  width: 100%;
}
.form-logo {
  width: 152px;
  height: 136px;
  margin: 22px auto 68px;
  background: url("~@/assets/logo.svg") no-repeat center;
  background-size: cover;
}
.login-bj {
  background: url("~@/assets/login-bj.png") no-repeat center bottom;
}
.login-content {
  width: 640px;
  margin: 0 auto;
}
.user {
  padding: 80px 0;
  background: #fff;
  margin-top: 100px;
  margin-bottom: 246px;
  display: flex;
}
.login-ad {
  width: 519px;
  margin-left: 120px;
  border-right: 1px solid #e3e6e4;
  h1 {
    margin-bottom: 20px;
  }
  p {
    line-height: 30px;
    font-size: 16px;
    color: #666666;
  }
}
.login-form {
  margin: 0 40px;
  .el-input__icon {
    font-size: 20px;
    margin-right: 10px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
}
</style>